import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-rsvn',
  templateUrl: './button-rsvn.component.html',
  styleUrls: ['./button-rsvn.component.scss']
})
export class ButtonRsvnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
